import React, { useState } from 'react'

import './dashboard.css'

import "react-responsive-modal/styles.css";
import Breadcrumbs from '../layout/breadcrumb';
import Tiles from '../../compnenets/commons/tiles';


function Dashboard() {

    

    return (
        <div >
            <Breadcrumbs/>
           <Tiles/>
        </div>
    )
}

export default Dashboard
